import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import FunctionGeneral from '../functionsGeneral';
import ContractsService from '../../../../services/ContractsService';
import Globals from '../../../../Globals';
import Loading from '../../../bronson/Loading';
import Input from '../../../bronson/Input';
import ListadoFiltro from './ListadoFiltro';

const ModalCancelacionesPropias = props => {
    const [loaded, setloaded] = useState(false);
    const [typeValue, setTypeValue] = useState('');
    const [ownContractList, setOwnContractList] = useState([]);
    const [selectedContract, setSelectedContract] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [filter, setFilter] = useState('');

    useEffect(() => {
        window.bronson.ComponentRegister.initAll();
        CargarContratosPropios(props);
        showList();
    }, []);

    const showList = () => {
        setIsOpen(true);
    };

    const hideList = () => {
        setIsOpen(false);
    };

    async function filterChange(operationCode) {
        setSelectedContract(true);
        setFilter(operationCode);
    }

    async function updateFilter(value) {
        setSelectedContract(false);
        setFilter(value);
    }

    const filteredItems = ownContractList?.filter(item =>
        selectedContract || filter == ''
            ? item
            : item.operation_code.toLowerCase().includes(filter.toLowerCase())
    );

    async function CargarContratosPropios(props) {
        const jwtCookie = props.cookies.get(Globals.COOKIES.JWT);
        const accessToken = jwtCookie && jwtCookie.AccessToken;

        if (!accessToken || !props.dealerCodeVWF) {
            setloaded(false);
            return;
        }

        setloaded(true);
        const _dataContratosCliente = await new ContractsService().cargarContratosPropios(
            accessToken,
            props.dealerCodeVWF
        );

        if (
            _dataContratosCliente &&
            _dataContratosCliente.statusCode === 200 &&
            _dataContratosCliente.body &&
            _dataContratosCliente.body.Result
        ) {
            setOwnContractList(JSON.parse(_dataContratosCliente.body.Result));
        }

        setloaded(false);
    }

    return (
        <React.Fragment>
            <Loading ariaBusy={loaded}></Loading>
            <div className="c-modal" aria-hidden={'false'}>
                <div className="c-modal__overlay js-modal-close"></div>
                <div
                    className="c-modal__wrapper modalCancelacionPropia"
                    role="dialog"
                    aria-labelledby="foo-bar-baz"
                >
                    <header className="c-modal__header">
                        <div className="o-layout__item u-11/12">
                            <div className="u-1/1">
                                <div className="c-icon colorBlue iconContrato" />
                                <label className="u-h3 u-ml-xsmall">
                                    Cancelaciones propias
                                </label>
                            </div>
                        </div>
                        <div className="o-layout__item u-1/12">
                            <button
                                onClick={() => {
                                    props.setModalCancelacionesPropias(false);
                                }}
                                className="c-modal__close-btn  js-modal-close"
                                type="button"
                                aria-label="Close this dialog window."
                            />
                        </div>
                    </header>
                    {
                        <div className="c-modal__content ContratosModal">
                            <div className="gridContainerModal o-layout">
                                <div
                                    className="o-layout__item u-1/1 fc-margintop-10"
                                    style={{ marginTop: '40px' }}
                                >
                                    <label className="u-text-base u-1/1 u-text-left">
                                        Selecciona el contrato sobre el que
                                        quiere realizar la cancelación:
                                    </label>
                                    <div className="o-layout__item u-1/1 fc-margintop-10">
                                        <div className="c-form-field__box u-5/5">
                                            <div className="o-layout__item u-1/1">
                                                <div className="c-custom-select">
                                                    <div className="c-input">
                                                        <input
                                                            className="c-input__input"
                                                            autoComplete="off"
                                                            type="text"
                                                            placeholder="Selecciona un contrato"
                                                            value={filter}
                                                            onChange={e =>
                                                                updateFilter(
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                        />
                                                        <button
                                                            className={`c-input__addon  c-input__addon--no-background u-pl-none u-pr-none`}
                                                            style={{
                                                                cursor:
                                                                    'context-menu',
                                                            }}
                                                        >
                                                            <i className="c-icon  c-icon--[semantic-search]"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div
                                                    className="c-custom-select"
                                                    style={{
                                                        display: 'block',
                                                        minHeight: '250px',
                                                        maxHeight: '250px',
                                                        overflowY: 'scroll',
                                                    }}
                                                >
                                                    <ul
                                                        id="ul_bronson"
                                                        className="c-custom-select__dropdown"
                                                        style={{
                                                            display: !isOpen
                                                                ? 'none'
                                                                : 'contents',
                                                        }}
                                                    >
                                                        {(!selectedContract &&
                                                            filteredItems.length !==
                                                                0) ||
                                                        filter !== ''
                                                            ? filteredItems.map(
                                                                  (
                                                                      contract,
                                                                      index
                                                                  ) => {
                                                                      return (
                                                                          <li
                                                                              id={
                                                                                  'li_bronson_' +
                                                                                  index
                                                                              }
                                                                              key={
                                                                                  contract.operation_code
                                                                              }
                                                                              className={
                                                                                  'c-custom-select__item  ' +
                                                                                  (contract.operation_code ==
                                                                                  filter
                                                                                      ? 'is-active'
                                                                                      : '')
                                                                              }
                                                                              onClick={() =>
                                                                                  filterChange(
                                                                                      contract.operation_code
                                                                                  )
                                                                              }
                                                                          >
                                                                              {'Contrato: ' +
                                                                                  contract.operation_code +
                                                                                  ' - ' +
                                                                                  contract.propduct_type +
                                                                                  ' - Nº Vehículos: ' +
                                                                                  contract.cars_quantity +
                                                                                  ' - Fecha Vto.: ' +
                                                                                  contract.endDateContract +
                                                                                  ' - Capital Pendiente: ' +
                                                                                  contract.pendingCapital +
                                                                                  ' - Importe prox. Cuota: ' +
                                                                                  contract.nextAmount}
                                                                          </li>
                                                                      );
                                                                  }
                                                              )
                                                            : ownContractList.map(
                                                                  (
                                                                      contract,
                                                                      index
                                                                  ) => {
                                                                      return (
                                                                          <li
                                                                              id={
                                                                                  'li_bronson_' +
                                                                                  index
                                                                              }
                                                                              key={
                                                                                  contract.operation_code
                                                                              }
                                                                              className={
                                                                                  'c-custom-select__item  ' +
                                                                                  (contract.operation_code ==
                                                                                  filter
                                                                                      ? 'is-active'
                                                                                      : '')
                                                                              }
                                                                              onClick={() =>
                                                                                  filterChange(
                                                                                      contract.operation_code
                                                                                  )
                                                                              }
                                                                          >
                                                                              {'Contrato: ' +
                                                                                  contract.operation_code +
                                                                                  ' - ' +
                                                                                  contract.propduct_type +
                                                                                  ' - Nº Vehículos: ' +
                                                                                  contract.cars_quantity +
                                                                                  ' - Fecha Vto.: ' +
                                                                                  contract.endDateContract +
                                                                                  ' - Capital Pendiente: ' +
                                                                                  contract.pendingCapital +
                                                                                  ' - Importe prox. Cuota: ' +
                                                                                  contract.nextAmount}
                                                                          </li>
                                                                      );
                                                                  }
                                                              )}
                                                    </ul>
                                                </div>
                                                <div className="o-layout__item u-1/1"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="o-layout__item u-1/3 u-text-center">
                                <button
                                    className="u-text-brand c-btn scoring-table-button u-float-left"
                                    style={{ width: '100%' }}
                                    disabled={!selectedContract}
                                    onClick={() => {
                                        props.setFinancialOperationCodeLPO(
                                            filter //'01RN92050443'//selectedContract
                                        );
                                        props.setModalCancelacionesPropias(
                                            false
                                        );
                                    }}
                                >
                                    CONTINUAR
                                </button>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </React.Fragment>
    );
};
export default withRouter(ModalCancelacionesPropias);
